import React from 'react';

const CouponTable = ({ ads, selectedRows, handleRowSelect, handleSelectAll, selectAll, removeRow, isDark, currentPage, pageSize, selectedDealStateFilter, showDealStateDropdown, setShowDealStateDropdown, getUniqueDealStates, handleDealStateFilter, selectedDealTypeFilter, showDealTypeDropdown, setShowDealTypeDropdown, getUniqueDealTypes, handleDealTypeFilter, selectedDealScopeFilter, showDealScopeDropdown, setShowDealScopeDropdown, getUniqueDealScopes, handleDealScopeFilter, selectedDiscountTypeFilter, showDiscountTypeDropdown, setShowDiscountTypeDropdown, getUniqueDiscountTypes, handleDiscountTypeFilter, selectedAdvertiserFilter, showAdvertiserDropdown, setShowAdvertiserDropdown, getUniqueAdvertisers, handleAdvertiserFilter, selectedTypeFilter, showTypeDropdown, setShowTypeDropdown, getUniqueTypes, handleTypeFilter, selectedDiscountCurrencyFilter, showDiscountCurrencyDropdown, setShowDiscountCurrencyDropdown, getUniqueDiscountCurrencies, handleDiscountCurrencyFilter }) => {
  return (
    <div className="perzsi-table-container">
      <div className="overflow-x-auto">
        <table className="perzsi-table">
          <thead>
            <tr>
              <th className="w-16">
                <input
                  type="checkbox"
                  checked={selectAll}
                  onChange={handleSelectAll}
                  className="w-5 h-5 rounded border-2 border-gray-300 text-perzsi-yellow focus:ring-2 focus:ring-perzsi-yellow focus:border-perzsi-yellow cursor-pointer"
                />
              </th>
              <th>Name</th>
              <th>Description</th>
              <th>
                <div className="flex items-center justify-between">
                  <span>
                    Advertiser {selectedAdvertiserFilter && `(${selectedAdvertiserFilter})`}
                  </span>
                  <div className="relative">
                    <button
                      onClick={() => setShowAdvertiserDropdown(!showAdvertiserDropdown)}
                      className={`ml-2 px-2 py-1 text-xs bg-transparent ${isDark ? 'text-white' : 'text-gray-900'} border-none cursor-pointer font-bold text-lg leading-none hover:bg-white hover:bg-opacity-20 rounded`}
                    >
                      ▼
                    </button>
                    {showAdvertiserDropdown && (
                      <div className="absolute right-0 top-full mt-1 w-48 bg-white border border-gray-300 rounded-md shadow-lg z-10">
                        <div
                          onClick={() => {
                            handleAdvertiserFilter('');
                            setShowAdvertiserDropdown(false);
                          }}
                          className={`px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
                            selectedAdvertiserFilter === '' ? 'bg-yellow-50 text-perzsi-gray font-semibold' : 'text-gray-700'
                          }`}
                        >
                          All Advertisers
                        </div>
                        {getUniqueAdvertisers().map((advertiser) => (
                          <div
                            key={advertiser}
                            onClick={() => {
                              handleAdvertiserFilter(advertiser);
                              setShowAdvertiserDropdown(false);
                            }}
                            className={`px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
                              selectedAdvertiserFilter === advertiser ? 'bg-yellow-50 text-perzsi-gray font-semibold' : 'text-gray-700'
                            }`}
                          >
                            {advertiser}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </th>
              <th>Campaign</th>
              <th>Tracking Link</th>
              <th>Deal Name</th>
              <th>
                <div className="flex items-center justify-between">
                  <span>
                    Deal State {selectedDealStateFilter && `(${selectedDealStateFilter})`}
                  </span>
                  <div className="relative">
                    <button
                      onClick={() => setShowDealStateDropdown(!showDealStateDropdown)}
                      className={`ml-2 px-2 py-1 text-xs bg-transparent ${isDark ? 'text-white' : 'text-gray-900'} border-none cursor-pointer font-bold text-lg leading-none hover:bg-white hover:bg-opacity-20 rounded`}
                    >
                      ▼
                    </button>
                    {showDealStateDropdown && (
                      <div className="absolute right-0 top-full mt-1 w-48 bg-white border border-gray-300 rounded-md shadow-lg z-10">
                        <div
                          onClick={() => {
                            handleDealStateFilter('');
                            setShowDealStateDropdown(false);
                          }}
                          className={`px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
                            selectedDealStateFilter === '' ? 'bg-yellow-50 text-perzsi-gray font-semibold' : 'text-gray-700'
                          }`}
                        >
                          All Deal States
                        </div>
                        {getUniqueDealStates().map((dealState) => (
                          <div
                            key={dealState}
                            onClick={() => {
                              handleDealStateFilter(dealState);
                              setShowDealStateDropdown(false);
                            }}
                            className={`px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
                              selectedDealStateFilter === dealState ? 'bg-yellow-50 text-perzsi-gray font-semibold' : 'text-gray-700'
                            }`}
                          >
                            {dealState}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </th>
              <th>
                <div className="flex items-center justify-between">
                  <span>
                    Deal Type {selectedDealTypeFilter && `(${selectedDealTypeFilter})`}
                  </span>
                  <div className="relative">
                    <button
                      onClick={() => setShowDealTypeDropdown(!showDealTypeDropdown)}
                      className={`ml-2 px-2 py-1 text-xs bg-transparent ${isDark ? 'text-white' : 'text-gray-900'} border-none cursor-pointer font-bold text-lg leading-none hover:bg-white hover:bg-opacity-20 rounded`}
                    >
                      ▼
                    </button>
                    {showDealTypeDropdown && (
                      <div className="absolute right-0 top-full mt-1 w-48 bg-white border border-gray-300 rounded-md shadow-lg z-10">
                        <div
                          onClick={() => {
                            handleDealTypeFilter('');
                            setShowDealTypeDropdown(false);
                          }}
                          className={`px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
                            selectedDealTypeFilter === '' ? 'bg-yellow-50 text-perzsi-gray font-semibold' : 'text-gray-700'
                          }`}
                        >
                          All Deal Types
                        </div>
                        {getUniqueDealTypes().map((dealType) => (
                          <div
                            key={dealType}
                            onClick={() => {
                              handleDealTypeFilter(dealType);
                              setShowDealTypeDropdown(false);
                            }}
                            className={`px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
                              selectedDealTypeFilter === dealType ? 'bg-yellow-50 text-perzsi-gray font-semibold' : 'text-gray-700'
                            }`}
                          >
                            {dealType}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </th>
              <th>
                <div className="flex items-center justify-between">
                  <span>
                    Deal Scope {selectedDealScopeFilter && `(${selectedDealScopeFilter})`}
                  </span>
                  <div className="relative">
                    <button
                      onClick={() => setShowDealScopeDropdown(!showDealScopeDropdown)}
                      className={`ml-2 px-2 py-1 text-xs bg-transparent ${isDark ? 'text-white' : 'text-gray-900'} border-none cursor-pointer font-bold text-lg leading-none hover:bg-white hover:bg-opacity-20 rounded`}
                    >
                      ▼
                    </button>
                    {showDealScopeDropdown && (
                      <div className="absolute right-0 top-full mt-1 w-48 bg-white border border-gray-300 rounded-md shadow-lg z-10">
                        <div
                          onClick={() => {
                            handleDealScopeFilter('');
                            setShowDealScopeDropdown(false);
                          }}
                          className={`px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
                            selectedDealScopeFilter === '' ? 'bg-yellow-50 text-perzsi-gray font-semibold' : 'text-gray-700'
                          }`}
                        >
                          All Deal Scopes
                        </div>
                        {getUniqueDealScopes().map((dealScope) => (
                          <div
                            key={dealScope}
                            onClick={() => {
                              handleDealScopeFilter(dealScope);
                              setShowDealScopeDropdown(false);
                            }}
                            className={`px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
                              selectedDealScopeFilter === dealScope ? 'bg-yellow-50 text-perzsi-gray font-semibold' : 'text-gray-700'
                            }`}
                          >
                            {dealScope}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </th>
              <th>Deal Public</th>
              <th>
                <div className="flex items-center justify-between">
                  <span>
                    Discount Type {selectedDiscountTypeFilter && `(${selectedDiscountTypeFilter})`}
                  </span>
                  <div className="relative">
                    <button
                      onClick={() => setShowDiscountTypeDropdown(!showDiscountTypeDropdown)}
                      className={`ml-2 px-2 py-1 text-xs bg-transparent ${isDark ? 'text-white' : 'text-gray-900'} border-none cursor-pointer font-bold text-lg leading-none hover:bg-white hover:bg-opacity-20 rounded`}
                    >
                      ▼
                    </button>
                    {showDiscountTypeDropdown && (
                      <div className="absolute right-0 top-full mt-1 w-48 bg-white border border-gray-300 rounded-md shadow-lg z-10">
                        <div
                          onClick={() => {
                            handleDiscountTypeFilter('');
                            setShowDiscountTypeDropdown(false);
                          }}
                          className={`px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
                            selectedDiscountTypeFilter === '' ? 'bg-yellow-50 text-perzsi-gray font-semibold' : 'text-gray-700'
                          }`}
                        >
                          All Discount Types
                        </div>
                        {getUniqueDiscountTypes().map((discountType) => (
                          <div
                            key={discountType}
                            onClick={() => {
                              handleDiscountTypeFilter(discountType);
setShowDiscountTypeDropdown(false);
                            }}
                            className={`px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
                              selectedDiscountTypeFilter === discountType ? 'bg-yellow-50 text-perzsi-gray font-semibold' : 'text-gray-700'
                            }`}
                          >
                            {discountType}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </th>
              <th>Discount Amount</th>
              <th>
                <div className="flex items-center justify-between">
                  <span>
                    Discount Currency {selectedDiscountCurrencyFilter && `(${selectedDiscountCurrencyFilter})`}
                  </span>
                  <div className="relative">
                    <button
                      onClick={() => setShowDiscountCurrencyDropdown(!showDiscountCurrencyDropdown)}
                      className={`ml-2 px-2 py-1 text-xs bg-transparent ${isDark ? 'text-white' : 'text-gray-900'} border-none cursor-pointer font-bold text-lg leading-none hover:bg-white hover:bg-opacity-20 rounded`}
                    >
                      ▼
                    </button>
                    {showDiscountCurrencyDropdown && (
                      <div className="absolute right-0 top-full mt-1 w-48 bg-white border border-gray-300 rounded-md shadow-lg z-10">
                        <div
                          onClick={() => {
                            handleDiscountCurrencyFilter('');
                            setShowDiscountCurrencyDropdown(false);
                          }}
                          className={`px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
                            selectedDiscountCurrencyFilter === '' ? 'bg-yellow-50 text-perzsi-gray font-semibold' : 'text-gray-700'
                          }`}
                        >
                          All Currencies
                        </div>
                        {getUniqueDiscountCurrencies().map((currency) => (
                          <div
                            key={currency}
                            onClick={() => {
                              handleDiscountCurrencyFilter(currency);
                              setShowDiscountCurrencyDropdown(false);
                            }}
                            className={`px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
                              selectedDiscountCurrencyFilter === currency ? 'bg-yellow-50 text-perzsi-gray font-semibold' : 'text-gray-700'
                            }`}
                          >
                            {currency}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </th>
              <th>Discount Percent</th>
              <th>Promo Code</th>
              <th>
                <div className="flex items-center justify-between">
                  <span>
                    Type {selectedTypeFilter && `(${selectedTypeFilter})`}
                  </span>
                  <div className="relative">
                    <button
                      onClick={() => setShowTypeDropdown(!showTypeDropdown)}
                      className={`ml-2 px-2 py-1 text-xs bg-transparent ${isDark ? 'text-white' : 'text-gray-900'} border-none cursor-pointer font-bold text-lg leading-none hover:bg-white hover:bg-opacity-20 rounded`}
                    >
                      ▼
                    </button>
                    {showTypeDropdown && (
                      <div className="absolute right-0 top-full mt-1 w-48 bg-white border border-gray-300 rounded-md shadow-lg z-10">
                        <div
                          onClick={() => {
                            handleTypeFilter('');
                            setShowTypeDropdown(false);
                          }}
                          className={`px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
                            selectedTypeFilter === '' ? 'bg-yellow-50 text-perzsi-gray font-semibold' : 'text-gray-700'
                          }`}
                        >
                          All Types
                        </div>
                        {getUniqueTypes().map((type) => (
                          <div
                            key={type}
                            onClick={() => {
                              handleTypeFilter(type);
                              setShowTypeDropdown(false);
                            }}
                            className={`px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
                              selectedTypeFilter === type ? 'bg-yellow-50 text-perzsi-gray font-semibold' : 'text-gray-700'
                            }`}
                          >
                            {type}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {ads.map((ad, index) => {
              const globalIndex = (currentPage - 1) * pageSize + index;
              const isSelected = selectedRows.has(globalIndex);

              return (
                <tr key={index} className={isSelected ? (isDark ? 'bg-blue-900/30' : 'bg-yellow-50') : (isDark ? 'hover:bg-gray-700' : 'hover:bg-gray-50')}>
                  <td>
                    <input
                      type="checkbox"
                      checked={isSelected}
                      onChange={() => handleRowSelect(index)}
                      className="w-5 h-5 rounded border-2 border-gray-300 text-perzsi-yellow focus:ring-2 focus:ring-perzsi-yellow focus:border-perzsi-yellow cursor-pointer"
                    />
                  </td>
                  <td className="font-medium">{ad.Name}</td>
                  <td className="max-w-xs truncate">{ad.Description}</td>
                  <td>{ad.AdvertiserName}</td>
                  <td>{ad.CampaignName}</td>
                  <td className="max-w-xs">
                    {ad.TrackingLink && (
                      <div>
                        <a
                          href={ad.TrackingLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 hover:text-blue-800 underline font-medium"
                        >
                          Link
                        </a>
                      </div>
                    )}
                  </td>
                  <td>{ad.DealName}</td>
                  <td>{ad.DealState}</td>
                  <td>{ad.DealType}</td>
                  <td>{ad.DealScope}</td>
                  <td>{ad.DealPublic}</td>
                  <td>{ad.DiscountType}</td>
                  <td>{ad.DiscountAmount}</td>
                  <td>{ad.DiscountCurrency}</td>
                  <td>{ad.DiscountPercent}</td>
                  <td>{ad.DealDefaultPromoCode}</td>
                  <td>{ad.Type}</td>
                  <td>
                    <button
                      className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded text-sm transition-colors duration-200"
                      onClick={() => removeRow(index)}
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CouponTable;
